export class NavItem {
    title: string;
    route: string;
    url: string;
    isVisible: boolean;
    routeQueryParams: any;
    messageCount: number;
    indentLevel: number;

    constructor(title: string, route: string = null, url: string = null, isVisible: boolean = true, routeQueryParams: any = null, messageCount: number = null, indentLevel: number= 0) {
        this.title = title;
        this.route = route;
        this.url = url;
        this.isVisible = isVisible;
        this.routeQueryParams = routeQueryParams;
        this.messageCount = messageCount;
        this.indentLevel = indentLevel;
    }
}
